<template>
	<div class="home">
		<Hero class="row" :banners="randomizedBanners"></Hero>

		<OverviewSection class="row"></OverviewSection>

		<SectorSection class="row pt-0" :sectors="sectors"></SectorSection>

		<FeatureSection class="row"></FeatureSection>

		<WhitelistSection class="row pt-0"></WhitelistSection>

<!--		<PurchaseSection class="row"></PurchaseSection>-->

		<!--		<AboutSection class="row"></AboutSection>-->

		<ContactSection class="row"></ContactSection>

		<Footer></Footer>
	</div>
</template>

<script>
import sectorJson from "/public/map/sectors.json";
import Hero from "../components/home/HeroSection";
import SectorSection from "../components/home/SectorSection";
import FeatureSection from "../components/home/FeatureSection";
import WhitelistSection from "../components/home/WhitelistSection";
// import PurchaseSection from "../components/home/PurchaseSection";
// import AboutSection from "../components/home/AboutSection";
import Footer from "../components/Footer";
import ContactSection from "../components/home/ContactSection";
import OverviewSection from "../components/home/OverviewSection";

export default {
	name: "LandHome",
	components: {
		OverviewSection,
		ContactSection,
		Footer,
		// AboutSection,
		// PurchaseSection,
		WhitelistSection,
		FeatureSection,
		SectorSection,
		Hero,
	},
	data() {
		return {
			heroBanners: [
				// {src: '/content/hero/1.jpg', isVideo: false},
				{src: '/content/hero/stadium_preview.mp4', isVideo: true},
				// {src: '/content/hero/2.jpg', isVideo: false},
				// {src: '/content/hero/3.jpg', isVideo: false},
				// {src: '/content/hero/4.jpg', isVideo: false},
				// {src: '/content/hero/1_mov.mp4', isVideo: true}
			],
			sectors: sectorJson,
		}
	},
	computed: {
		randomizedBanners() {
			return this.shuffle(this.heroBanners)
		},
	},
	methods: {

		navigate(url) {
			window.location.href = url;
		},
		shuffle(array) {
			let currentIndex = array.length, randomIndex;
			while (currentIndex !== 0) {
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex--;
				[array[currentIndex], array[randomIndex]] = [
					array[randomIndex], array[currentIndex]];
			}

			return array;
		}
	}
}
</script>

<style scoped>

.home {
	color: white;
}

h6 {
	text-transform: uppercase;
}

link {
	cursor: pointer;
}

.gleam-frame {
	width: 100%;
	height: 1400px;
	overflow: hidden;
	border-radius: 9px;
}

</style>